import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`relative py-6 px-4 sm:p-8 pb-16 sm:pb-20 lg:pb-28`};
  color: var(--color-white);
  background-color: var(--color-black-bean);

  &::before {
    content: '';
    ${tw`absolute left-0 bottom-0 w-full h-16 sm:h-20 lg:h-24`};
    background-color: var(--color-seal-brown);
    clip-path: polygon(0 38%, 100% 0, 100% 100%, 0 100%);
  }
`

export const Meta = styled.div`
  ${tw`relative z-10 grid gap-y-4`}
`

export const MetaItem = styled.div`
  ${tw`grid sm:grid-cols-2 lg:grid-cols-none`}
`
